import { HorizontalDotsMinor } from '@shopify/polaris-icons'
import React, { memo, useCallback, useContext, MouseEvent } from 'react'
import { Button } from 'src/components/shared/Button'
import { Opportunity } from 'src/interfaces/opportunity'
import { OpportunitiesTableContext } from './OpportunitiesTable.context'

interface Props {
  opportunity: Opportunity
}

const OpportunityActionButtonComponent = ({ opportunity }: Props) => {
  const { openOpportunityItemAction } = useContext(OpportunitiesTableContext)

  const handleClickAction = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      openOpportunityItemAction(event, opportunity)
    },
    [opportunity, openOpportunityItemAction],
  )

  return (
    <Button
      color="white"
      size="tiny"
      leftIcon={<HorizontalDotsMinor width={20} height={20} />}
      onClick={handleClickAction}
      data-testid={`opportunities-list-row-${opportunity.id}-actions-btn`}
    />
  )
}

export const OpportunityActionButton = memo(OpportunityActionButtonComponent)
